import './ResetPwd.scss'
import React, { useEffect, useState, useRef } from 'react';
import withRouter from '../../hoc/withRouter'
import { Button, Checkbox, Form, Input, Space, Select } from 'antd';
import loginApi from '../../request/api/loginapi'
import { Utils } from '../../utils';
import { useCooldown } from '../../utils/useCooldown';
import { Statistic } from 'antd';
import SCSvg from '../../assets/svg/servicecool.svg';
const { Countdown } = Statistic;
function ResetPwd({ router, showLogin }) {
    // 将所有需要的变量都放到最顶上********************************************************************
    // 展示提示信息
    const { showMessage } = Utils();
    // 表单全部数据结构
    let [resetPwdData, setresetPwdData] = useState({});
    const [checkLogin, setCheckLogin] = useState(false); //检查账户是否已绑定
    const [selectedAreaCode, setSelectedAreaCode] = useState('0086');
    const areaCodeRef = useRef('0086');
    const [formInfo, setFormInfo] = useState({
        mobile: {
            label: '手机号码',
            required: true,
            type: 'text',
            placeholder: '请输入手机号码',
            show: false,
            rule: 'mobile',
            controlInfo: '',
            extra: "",
            callBack: () => ({
                validator(_, val) {
                    if (!val) {
                        return Promise.reject('');
                    }
                    const mobileStr = areaCodeRef?.current + val;
                    if (!/^(?:00852\d{8}|00853\d{8}|00861[3-9]\d{9})$/?.test(mobileStr)) {
                        return Promise.reject('请输入正确的手机号码格式');
                    }
                    if (bindAccRef.current) {
                        const reg = new RegExp(`(?!^${bindAccRef.current}$)^1[0-9]{10}$`);
                        bindAccRef.current = '';
                        if (!reg.test(val)) {
                            return Promise.reject('账户未绑定，请前往注册。');
                        }
                    }
                    return Promise.resolve();
                }
            }),
        },
        captcha: {
            label: '验证码',
            required: true,
            type: 'text',
            placeholder: '请输入验证码',
            show: false,
            rule: '',
            controlInfo: '',
            // extra: "验证码十分钟内有效",
            pattern: new RegExp(/^\d{6}$/),
            ruleMsg: '验证码错误',
            callBack: () => ({
                validator() {
                    return Promise.resolve();
                },
            }),
        },
        resetPwdPwd: {
            label: '密码',
            required: true,
            type: 'password',
            placeholder: '请输入密码',
            pattern: new RegExp(/((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])|(?=.*[0-9])((?=.*[a-z])|(?=.*[A-Z]))(?=.*[!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`]))^[0-9A-Za-z!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`]{8,}$/),
            ruleMsg: '至少 8 位，至少包含数字, 大写字母, 小写字母, 特殊字符中的 3 项',
            callBack: () => ({
                validator() {
                    return Promise.resolve();
                },
            }),
            dependencies: ['resetPwdPwd']
        },
        confirmPwd: {
            label: '确认密码',
            required: true,
            type: 'password',
            placeholder: '请再次输入密码',
            pattern: new RegExp(/((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])|(?=.*[0-9])((?=.*[a-z])|(?=.*[A-Z]))(?=.*[!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`]))^[0-9A-Za-z!@#$%^&*()_+=\-~[\]{};':"\\|,./<>?`]{8,}$/),
            ruleMsg: '至少 8 位，至少包含数字, 大写字母, 小写字母, 特殊字符中的 3 项',
            callBack: ({ getFieldValue }) => ({
                validator(_, value) {
                    if (!value || getFieldValue('resetPwdPwd') == value) {
                        return Promise.resolve();
                    }
                    return Promise.reject(new Error('密码不匹配'));
                },
            }),
            dependencies: ['resetPwdPwd']
        },
        nextStep: {
            label: '下一步',
            type: 'primary',
            loading: false,
            className: 'next-step width100',
            disabled: true,
        },
        confirm: {
            label: '提交',
            type: 'primary',
            loading: false,
            className: 'next-step width100',
            disabled: true,
        },
    });
    // 显示计时器
    const [showResend, setShowResend] = useState(true);
    // 下一步 / 确认遇到限速 429 时禁用 N 秒（#897）
    const [stepCooling, startStepCooldown] = useCooldown();
    const [time, setTime] = useState(Date.now() + 1000 * 60);
    // 重置密码表单的变量及方法start
    const [resetPwd, setresetPwd] = useState<any[]>(['mobile', 'captcha', 'operate']);
    const [resetPwdBtnList, setresetPwdBtnList] = useState<any[]>(['nextStep']);
    const [resetPwdForm] = Form.useForm();
    const resetPwdValues = Form.useWatch([], resetPwdForm);
    const [bindAcc, setBindAcc] = useState('');
    const bindAccRef = useRef('');
    const [errcode, setErrCode] = useState('');
    // 然后将钩子函数放到第二个位置**************************************************************
    // 监听表单字段有效时取消按钮的禁用效果
    useEffect(() => {
        if (checkLogin && resetPwdValues?.mobile && bindAcc) {
            setBindAcc('');
            setCheckLogin(false);
        } else if (resetPwdValues?.captcha && errcode) {
            setFromInfoVal('captcha', { pattern: new RegExp(`(?!^${errcode}$)^\d{6}$`) });
            setErrCode('');
        } else {
            setFromInfoVal('captcha', { pattern: new RegExp(/^\d{6}$/) });
        }
        const list = Object.values(resetPwdValues || {});
        const arr = list.filter(item => {
            if (item) {
                return true;
            }
        })
        if (arr.length && arr.length == list.length) {
            resetPwdForm.validateFields().then(
                () => {
                    if (resetPwdValues?.mobile) {
                        setFromInfoVal('nextStep', { disabled: false });
                    } else {
                        setFromInfoVal('confirm', { disabled: false });
                    }
                },
                () => {
                    if (resetPwdValues?.mobile) {
                        setFromInfoVal('nextStep', { disabled: true });
                    } else {
                        setFromInfoVal('confirm', { disabled: true });
                    }
                },
            ).catch(() => { });
        } else {
            if (resetPwdValues?.mobile) {
                setFromInfoVal('nextStep', { disabled: true });
            } else {
                setFromInfoVal('confirm', { disabled: true });
            }
        }
    }, [resetPwdValues])
    // 然后将处理函数放到第三个位置**************************************************************
    // 修改formInfo中某个按钮的某个属性值
    const setFromInfoVal = (filed, data) => {
        let obj = { ...formInfo };
        obj[filed] = {
            ...obj[filed],
            ...data
        }
        setFormInfo(obj);
    }
    // 创建表单模板
    const getFormItem = (list, btnList, type?) => {
        const formList = list.map((key) => {
            if (key === 'mobile') {
                return (
                    <Form.Item key={key} label={formInfo[key]?.label}>
                        <Space.Compact block>
                            <Select
                                value={selectedAreaCode}
                                onChange={(e) => { setSelectedAreaCode(e); areaCodeRef.current = e; resetPwdForm.validateFields(['mobile']) }}
                                style={{
                                    minWidth: 140,
                                    width: 150
                                }}
                                options={[
                                    { value: '0086', label: '+86(中国大陆)' },
                                    { value: '00852', label: '+852(中国香港)' },
                                    { value: '00853', label: '+853(中国澳门)' }
                                ]}
                            />
                            <Form.Item
                                className={`sub-form-item mob-sub-formitem`}
                                name={key}
                                rules={[
                                    { required: formInfo[key]?.required, message: '值不能为空！', whitespace: true },
                                    formInfo[key]?.callBack
                                ]}
                                dependencies={formInfo[key]?.dependencies}
                                extra={formInfo[key]?.extra}
                            >
                                <Input type={formInfo[key]?.type} placeholder={formInfo[key]?.placeholder} autoComplete="off" />
                            </Form.Item>
                        </Space.Compact>
                        <div className='send-code'>
                            {showResend ?
                                <span className='pointer' onClick={() => { sendCode(type) }}>获取验证码</span> :
                                <Countdown value={time} onFinish={() => { setShowResend(true) }} format={"s"} suffix={'s后重新获取'} />
                            }
                        </div>
                    </Form.Item>
                );
            } else if (!['checked']?.includes(formInfo[key]?.type) && key != 'operate') {
                return (<Form.Item
                    key={key}
                    label={formInfo[key]?.label}
                >
                    <Space.Compact block>
                        <Form.Item
                            className='sub-form-item'
                            name={key}
                            rules={[{ required: formInfo[key]?.required, message: '值不能为空！', whitespace: true }, { pattern: formInfo[key]?.pattern, message: formInfo[key]?.ruleMsg }, formInfo[key]?.callBack]} dependencies={formInfo[key]?.dependencies}
                            extra={formInfo[key]?.extra}
                        >
                            {
                                ['resetPwdPwd', 'confirmPwd']?.includes(key) ? <Input.Password prefix={formInfo[key]?.prefix} type={formInfo[key]?.type} placeholder={formInfo[key]?.placeholder} autoComplete="off" /> :
                                    <Input prefix={formInfo[key]?.prefix} type={formInfo[key]?.type} placeholder={formInfo[key]?.placeholder} autoComplete="off" />
                            }
                        </Form.Item>
                    </Space.Compact>
                    {
                        key == 'mobile' ? <div className='send-code'>
                            {showResend ? <span className='pointer' onClick={() => { sendCode(type) }}>获取验证码</span> : <Countdown value={time} onFinish={() => { setShowResend(true) }} format={"s"} suffix={'s后重新获取'} />}
                        </div> : null
                    }
                </Form.Item >)
            } else if (formInfo[key]?.type == 'checked') {
                return (<Form.Item key={key}>
                    <Form.Item name={key} valuePropName={formInfo[key]?.type} noStyle rules={[
                        formInfo[key]?.callBack
                    ]}>
                        <Checkbox>{formInfo[key]?.label}</Checkbox>
                    </Form.Item>
                    {formInfo[key]?.link.map((link, index) => {
                        const str = index > 0 ? '和' : '';
                        return <div className='inline-block font-12' key={index}>
                            {str}
                            <a onClick={(event) => { operate(event, key, link) }}>
                                {link}
                            </a>
                        </div>
                    })
                    }
                </Form.Item>)
            } else if (key === 'operate') {
                return <Form.Item key={key}>
                    {
                        btnList.map(btn => {
                            return <Button key={btn} type={formInfo[btn]?.type} htmlType={formInfo[btn]?.htmlType} className={formInfo[btn]?.className} onClick={(event) => operate(event, btn)} loading={formInfo[btn]?.loading} disabled={formInfo[btn]?.disabled || (stepCooling && ['nextStep', 'confirm'].includes(btn))}>
                                {formInfo[btn]?.label}
                            </Button>
                        })
                    }
                </Form.Item>
            }
        });
        return formList;
    }
    // 发送验证码调用
    const sendCode = (type) => {
        if (type == 'resetPwd') {
            resetPwdForm.validateFields(['mobile']).then(res => {
                if (showResend) {
                    setTime(Date.now() + 1000 * 60);
                    const mobile = selectedAreaCode === '0086' ? res.mobile : selectedAreaCode + res.mobile;
                    loginApi.reqCode(mobile).then(res => {
                        showMessage("success", "发送成功请注意查收");
                    }).catch(err => {
                        if (err?.rateLimited) {
                            // 限速 429：倒计时改成 Retry-After 秒，期间不能再发（#897）
                            showMessage('error', err.error);
                            setTime(Date.now() + err.retryAfter * 1000);
                        } else if (err?.code == 3) {
                            showMessage('error', '验证码发送请求过多，请 1 分钟后重试。');
                        } else {
                            showMessage('error', err?.error);
                        }
                    })
                    setShowResend(false);
                } else {
                    showMessage('error', "请一分钟后再次发送！");
                }
            }).catch(() => { })
        } else {
            setShowResend(false);
        }
    }
    // 点击按钮进行的操作
    const operate = (e, btn, text?) => {
        e?.stopPropagation();
        const val = resetPwdForm.getFieldsValue() || {};
        switch (btn) {
            case 'nextStep':
                // 处理手机号格式
                const mobile = selectedAreaCode === '0086' ? val.mobile : selectedAreaCode + val.mobile;
                setresetPwdData(Object.assign({}, resetPwdData, { mobile: mobile, code: val.captcha }));
                // 这边需要发一个登录请求判断当前手机号有没有被绑定
                loginApi.checkBind({ mobile: mobile, code: val['captcha'] }).then(res => {
                    const data = res || {};
                    if (data['error'] == "无效的验证码" && !data['msg']) {
                        resetPwdForm.setFieldValue('captcha', null);
                        resetPwdForm.setFieldValue('captcha', val['captcha']);
                        setErrCode(val['captcha']);
                    } else if (!data['error'] && data['msg'] == "mobile already used") {
                        setresetPwd(['resetPwdPwd', 'confirmPwd', 'operate']);
                        setresetPwdBtnList(['confirm']);
                    } else if (!data['error'] && data['msg'] == "mobile available") {
                        resetPwdForm.setFieldValue('mobile', null);
                        resetPwdForm.setFieldValue('mobile', val['mobile']);
                        setCheckLogin(true);
                        bindAccRef.current = val.mobile;
                        setBindAcc(val.mobile);
                    }
                }).catch(err => {
                    if (err?.rateLimited) {
                        showMessage('error', err.error);
                        startStepCooldown(err.retryAfter);
                    }
                })
                break;
            case 'confirm':
                const param = {
                    pwd: resetPwdData['pwd'] || val?.resetPwdPwd,
                    mobile: resetPwdData['mobile'], // 这里已经是处理过的mobile值了
                    code: resetPwdData['code']
                };
                loginApi.resetPwd(param).then(res => {
                    showMessage('success', '重置密码成功');
                    showLogin && showLogin(false);
                }).catch(err => {
                    if (err?.rateLimited) {
                        showMessage('error', err.error);
                        startStepCooldown(err.retryAfter);
                    }
                })
                break;
            default:
                break;
        }
    }
    return (
        <div className='reset-pwd flex-start flex-space-between' data-component="reset-pwd">
            <div className='login-box align-items-center margin-auto'>
                <div className='parcel width100'>
                    <div className="flex-center" >
                        <div className='shrink-0 align-self-center bold font-33 margin-R10'>欢迎使用</div>
                        <img src={SCSvg} alt='' width={178} height={24} onClick={() => router.navigate('/home')} className='align-self-center' />
                    </div>
                    <div className='login-resetPwd'>
                        <div className='resetPwd-form-box'>
                            <div className='resetPwd-form-con'>
                                <Form
                                    name="normal_resetPwd"
                                    className="resetPwd-form"
                                    initialValues={{}}
                                    form={resetPwdForm}
                                    layout="vertical"
                                >
                                    {getFormItem(resetPwd, resetPwdBtnList, 'resetPwd')}
                                </Form>
                            </div>
                        </div>
                        <div className='prompt-action' onClick={() => { router.navigate('/login') }}><Button type="link" onClick={() => showLogin && showLogin(false)}>前往登录</Button></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withRouter(ResetPwd);